import { DynamicEnvironment } from './dynamic-environment';
import * as APPCONFIGS from 'src/resources/app-config.json';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

class Environment extends DynamicEnvironment{
  constructor(){
    super();
  }
}

export const environment = {
  production:false,
  aws: {
    Auth: {
      userPoolId: APPCONFIGS.userPoolId,
      userPoolClientId: APPCONFIGS.userPoolClientId
    }
  }
}

export const RuntimeEnvironment = new Environment();
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
